<template>
  <!-- FILTER -->
  <!-- Main container -->
  <nav class="level">
    <!-- Left side -->
    <div class="level-left">
      <div class="level-item">
        <p class="subtitle is-5">
         <span v-html="infoMsg"></span>
        </p>
      </div>
      <div class="level-item">
        <div class="field has-addons">
          <p class="control">
            <input class="input" v-on:keyup.enter="searchClick"  type="text" v-model="searchingText" placeholder="Find a post">
          </p>
          <p class="control">
            <button class="button" v-on:click="searchClick">
              Search
            </button>
          </p> 
        </div>
      </div>
        <div class="level-item">
          <p class="control">
            <slot name="customBtns">
            </slot>
          </p>
        </div>
    </div>

    <!-- Right side -->
    <div class="level-right">
      <div v-for="(group, index) in filterGroups" :key="index" class="level-item">
        <div v-if="curFilter === group">
          <p class="level-item">
            <strong class="bold" v-on:click="filtrate(group)">{{group}}</strong>
          </p>
        </div>
        <div v-else>
          <p class="level-item">
            <a class="bold" v-on:click="filtrate(group)">{{group}}</a>
          </p>
        </div>
      </div>
      <p v-if="createNewItem != undefined && this.userRole != 'readonly'" class="level-item">
        <a class="button is-success" v-on:click="createNewItem">New</a>
      </p>
    </div>
  </nav>
  <!-- END FILTER -->
</template>

<script>
export default {
  name: "content-filter",
  props: {
    createNewItem: Function,
    filterGroups: Array, //one item -> name
    infoMsg: String //HTML, e.g. count of the items
  },
  data() {
    return {
      curFilter: "",
      searchingText: ""
    };
  },
  methods: {
    //return filtration type to the parent
    filtrate(groupName) {
      this.curFilter = groupName;
      this.$emit("filtrate", groupName);
    },
    searchClick() {
      this.$emit("searchClick", this.searchingText);
      this.searchingText = "";
    }
  },
  created() {
    if (
      this.filterGroups !== null &&
      this.filterGroups != undefined &&
      this.filterGroups.length > 0
    )
      this.curFilter = this.filterGroups[0];
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ContentFilter.Vue